import { useEffect, useState } from 'react';
import { api } from './api';
import { DEFAULT_SETTINGS } from './defaults';
import type { SiteSettings } from './types';

/* Horaires et textes gérés depuis le dashboard.
   Rend les valeurs par défaut immédiatement, puis celles de l'API. */
export function useSiteSettings(): SiteSettings {
  const [settings, setSettings] = useState<SiteSettings>(DEFAULT_SETTINGS);

  useEffect(() => {
    if (typeof fetch !== 'function') return undefined;
    let cancelled = false;
    api<{ settings: SiteSettings }>('/settings')
      .then((data) => {
        if (!cancelled && data.settings && data.settings.hours.length > 0) {
          setSettings(data.settings);
        }
      })
      .catch(() => {
        /* on garde les valeurs par défaut */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return settings;
}
